export enum LayoutEnum {
  Default = 'default',
  Blank = 'blank',
}
